module.exports = __webpack_public_path__ + "static/img/3-ecosystem-2@2x.68a32bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx-mobile/3-ecosystem-2@2x.png
// module id = dxob
// module chunks = 12